import { FunctionComponent } from 'react'
import { RadioButton, RadioButtonProps } from './RadioButton'
import { RadioGroup } from './RadioGroup'
import { RADIO_BUTTON_DISPLAY_NAME, RADIO_DISPLAY_NAME, RADIO_FOOTER_DISPLAY_NAME, RADIO_GROUP_DISPLAY_NAME, RADIO_HEADER_DISPLAY_NAME } from './constants'
import { RadioFooter } from './RadioFooter'
import { RadioHeader } from './RadioHeader'

export type RadioVariantComponent = FunctionComponent<RadioButtonProps>

export type RadioComponent = typeof RadioButton & {
  Button: typeof RadioButton
  Group: typeof RadioGroup
  Footer: typeof RadioFooter
  Header: typeof RadioHeader
}

export const Radio = RadioButton as RadioComponent

export type { RadioButtonSizes } from './types'

Radio.Button = RadioButton
Radio.Group = RadioGroup
Radio.Footer = RadioFooter
Radio.Header = RadioHeader

Radio.displayName = RADIO_DISPLAY_NAME
RadioButton.displayName = RADIO_BUTTON_DISPLAY_NAME
RadioGroup.displayName = RADIO_GROUP_DISPLAY_NAME
RadioFooter.displayName = RADIO_FOOTER_DISPLAY_NAME
RadioHeader.displayName = RADIO_HEADER_DISPLAY_NAME
